<script>
import BitrixImage from "@/components/commonComponents/BitrixImage.vue";
import _ from "lodash";
import VBaseCardAjaxList from "@/components/commonComponents/VBaseCardAjaxList.vue";
import Clipboard from "@/mixins/Clipboard";

export default {
    name: "VCardEvents" ,
    components: {
        VBaseCardAjaxList,
        BitrixImage,
    },
    mixins: [Clipboard],
    props: {
        url: {
            type: String,
            required: true,
        },
        itemAvatarSize: {
            type: Number,
        },
    },
    methods: {
        getLinkToEvent(item) {
            return {name: 'ForumEvent', params: {ID_FORUM: item.FORUM?.VALUE || 0, ID_EVENT: item.ID}};
        },
        transformResponse(response) {
            return _.orderBy(response.data.data.items, v => v.DATE_START.VALUE, 'desc')
        }
    }
}
</script>

<template>
    <v-base-card-ajax-list
        :url="url"
        :transform="transformResponse"
        v-bind="$attrs"
        v-slot="{item}"
    >
        <v-list-item :key="item.ID" :to="getLinkToEvent(item)">
            <v-list-item-avatar :size="itemAvatarSize">
                <bitrix-image :file="item.LOGO?.FILE"></bitrix-image>
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-title>{{ item.NAME }}</v-list-item-title>
                <v-list-item-subtitle>{{ item.DATE_START.VALUE | moment('DD.MM.Y') }} -
                    {{ item.DATE_FINISH.VALUE | moment('DD.MM.Y') }}
                </v-list-item-subtitle>
                <v-list-item-subtitle
                    v-if="item.EPS_PROJECT_ID"
                    class="d-flex align-center"
                >
                    <span>projectId: {{ item.EPS_PROJECT_ID.VALUE }}</span>
                    <v-btn
                        icon
                        x-small
                        class="ml-1 show-on-hover"
                        @click.stop.prevent="copyToClipboard(item.EPS_PROJECT_ID.VALUE)"
                    >
                        <v-icon small>mdi-content-copy</v-icon>
                    </v-btn>
                </v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>
    </v-base-card-ajax-list>
</template>

<style scoped lang="scss">
.v-list-item .show-on-hover {
    opacity: 0;
    transition: .2s;
    pointer-events: none;
}
.v-list-item:hover .show-on-hover {
    opacity: 1;
    pointer-events: auto;
}

</style>